export { computeBlobMd5Hex, computeFileMd5Hex, formatFileSize } from './fileutils';

export const isStandalone = () => {
    return window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone ||
        document.referrer.includes('android-app://');
}

export const scrollToBottom = (container) => {
    if (!container) return;
    const modalContent = container.querySelector('.crgl-feedback-modal-content');
    if (modalContent) {
        modalContent.scrollTop = modalContent.scrollHeight;
    }
};